"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsFirstRender = void 0;
const react_1 = __importDefault(require("react"));
const useIsFirstRender = () => {
    const isFirstRender = react_1.default.useRef(true);
    react_1.default.useEffect(() => {
        isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
};
exports.useIsFirstRender = useIsFirstRender;
